// extracted by mini-css-extract-plugin
export var activityContainer = "_kz-0";
export var typingIndicatorContainer = "_kz-1";
export var typingIndicatorDot = "_kz-2";
export var wave = "_kz-3";